import React, { useEffect, useMemo, useState } from "react";
import { Edit,Plus, RefreshCcw,Trash2 } from "lucide-react";
import GSTInfoClient from "../../components/clients/GSTInfoClient";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import gstApi from "../../api/gstApi";
import { FiFile } from "react-icons/fi";
import { indianStatesWithGST } from "../../data/stateData";
import { confirmSubmit } from "../../utils/confirmSubmit";

const GSTInfoTab = ({ selectedClientData,onRefreshAccounts }) => {
    const [search, setSearch] = useState("");
    
    const [showCreateGst, setShowCreateGst] = useState(false);
    const [isGstId, setIsGstId] = useState(null);
    const [gstList, setGstList] = useState([]);
const businessInformationId = selectedClientData?.businessInformation?.id;
    const token = useSelector((state) => state.auth.access_token);
    const [isUpdateBasic, setIsUpdateBasic] = useState({
        id: null,
        registrationNumber: '',
        gstin: '',
        registrationType: 'Regular',
        activeStatus: true
    });
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const safeTrim = (value) => (value || "").trim();

        
const fetchGst = async () =>{
    setIsLoading(true)
    try {
        const res = await gstApi.getGstRegistrations(businessInformationId,token);
        setGstList(res.data)
    } catch (error) {
        console.log("GST Error : ",error);
    }finally{
        setIsLoading(false)
    }
    
}

useEffect(() => {
 fetchGst();
}, [])

    const [filters, setFilters] = useState({
        registrationType: "all",
        states: "all",
      });
    
      const filteredTasks = useMemo(() => {
        if (!gstList) return [];
    
        let tasks = [...gstList];

        const searchText = safeTrim(search).toLowerCase();
    
        // Filter
        if (filters.registrationType !== "all") {
          tasks = tasks.filter(
            (task) => task?.registrationType === filters.registrationType
          );
        }

        if (filters.states !== "all") {
            tasks = tasks.filter((task) => {
            const gstin = safeTrim(task?.gstin);
            const stateCode = gstin.substring(0, 2);
            return stateCode === filters.states;
            });
        }

        // 🔹 Search by GSTIN or Registration Number
        if (searchText) {
            tasks = tasks.filter((task) => {
            const gstin = safeTrim(task?.gstin).toLowerCase();
            const regNo = safeTrim(task?.registrationNumber).toLowerCase();

            return (
                gstin.includes(searchText) ||
                regNo.includes(searchText)
            );
            });
        }
    
        return tasks;
      }, [gstList, filters, search]);
    
      const gstType = [
        ...new Set(
          gstList
            ?.map((t) => t?.registrationType)
            .filter(Boolean)
        ),
      ];

    // const validateForm = () => {
    //     const newErrors = {};

    //     // if (!safeTrim(isUpdateBasic.registrationNumber)) {
    //     //     newErrors.registrationNumber = "Registration Number is required";
    //     // }

    //     if (!safeTrim(isUpdateBasic.gstin)) {
    //         newErrors.gstin = "GSTIN is required";
    //     } else if (
    //         !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/.test(
    //         safeTrim(isUpdateBasic.gstin)
    //         )
    //     ) {
    //         newErrors.gstin = "Invalid GSTIN format (e.g., 22ABCDE1234F1Z5)";
    //     }

    //     setErrors(newErrors);
    //     return Object.keys(newErrors).length === 0;
    //     };
const validateForm = async () => {
    const newErrors = {};

    const gstin = safeTrim(isUpdateBasic.gstin);

    if (!gstin) {
        newErrors.gstin = "GSTIN is required";
    } else if (
        !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/.test(gstin)
    ) {
        newErrors.gstin = "Invalid GSTIN format (e.g., 22ABCDE1234F1Z5)";
    } else {
        try {
            const res = await gstApi.searchGstNo(gstin, token);

            if (res?.results.length > 0) {
                newErrors.gstin = "GSTIN already exists";
            }
        } catch (err) {
            console.error("GST search error", err);
        }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
};

    const handelUpdate = async (e) => {
        e.preventDefault();
        if (selectedClientData?.businessInformation === null) {
            toast.error('Please first Add Business Information then Add GST details');
            return;
        }
        if (!validateForm()) {
            toast.error('Please complete existing GST details first');
            return;
        }
      try {
        setIsLoading(true);
        if (isGstId) {
            await gstApi.updateGstRegistration(isUpdateBasic?.id, isUpdateBasic, token);
            toast.success("GST Registration Update Successfully!");
            setIsUpdateBasic({
                id: null,
                registrationNumber: '',
                gstin: '',
                registrationType: 'Regular',
                activeStatus: true
                });
            onRefreshAccounts();
            fetchGst();
            setIsLoading(false);
            setShowCreateGst(false);
            setIsGstId(null);
        }else{
            await gstApi.createGstRegistration(selectedClientData?.businessInformation?.id, isUpdateBasic, token);
            toast.success("GST Registration New Successfully!");
            setIsUpdateBasic({
                id: null,
                registrationNumber: '',
                gstin: '',
                registrationType: 'Regular',
                activeStatus: true
                });
            onRefreshAccounts();
            setIsLoading(false);
            setShowCreateGst(false);
            fetchGst();
            setIsGstId(null);
        }
      } catch (error) {
        console.error("Error fetching account:", error);
        setIsLoading(false);
      } finally {
        setIsLoading(false);
      }
    };
    const handelDelete = async (e, id) => {
        e.preventDefault();
        const confirmed = await confirmSubmit({
                  title: "Confirm GST delete",
                  text: "Are you sure you want to delete this GST ?",
                  confirmText: "Submit",
                });

        if (!confirmed) return;
        setIsLoading(true);
      try {
            await gstApi.deleteGstRegistration(id, token);
            toast.success("GST Registration Delete Successfully!");
            setIsUpdateBasic({
                id: null,
                registrationNumber: '',
                gstin: '',
                registrationType: 'Regular',
                activeStatus: true
                });
            onRefreshAccounts();
            fetchGst();
            setShowCreateGst(false);
            setIsGstId(null);
      } catch (error) {
        console.error("Error fetching account:", error);
      } finally {
        setIsLoading(false);
      }
    };

    const [sortConfig, setSortConfig] = useState({
      key: null,
      direction: "asc", // asc | desc
    });
  
    const handleSort = (key) => {
      setSortConfig((prev) => {
        if (prev.key === key) {
          return {
            key,
            direction: prev.direction === "asc" ? "desc" : "asc",
          };
        }
        return { key, direction: "asc" };
      });
    };
  
    const getValueByPath = (obj, path) =>
        path.split(".").reduce((acc, key) => acc?.[key], obj);
  
  
      const sortedTasks = useMemo(() => {
        if (!sortConfig.key) return filteredTasks;
  
        return [...filteredTasks].sort((a, b) => {
          const aVal = getValueByPath(a, sortConfig.key);
          const bVal = getValueByPath(b, sortConfig.key);
  
          if (!aVal) return 1;
          if (!bVal) return -1;
  
          if (typeof aVal === "string") {
            return sortConfig.direction === "asc"
              ? aVal.localeCompare(bVal)
              : bVal.localeCompare(aVal);
          }
  
          return sortConfig.direction === "asc"
            ? aVal > bVal ? 1 : -1
            : aVal < bVal ? 1 : -1;
        });
      }, [filteredTasks, sortConfig]);
  
  
    const SortIcon = ({ column }) => {
      const isActive = sortConfig.key === column;
  
      return (
        <span className="inline-flex flex-col ml-1 text-[9px] leading-none">
          <span
            className={
              isActive && sortConfig.direction === "asc"
                ? "text-gray-900"
                : "text-gray-300"
            }
          >
            ▲
          </span>
          <span
            className={
              isActive && sortConfig.direction === "desc"
                ? "text-gray-900"
                : "text-gray-300"
            }
          >
            ▼
          </span>
        </span>
      );
    };

    return (
        <div className="space-y-2 bg-white p-2 rounded-lg">
            <div className="flex items-start justify-between">
                <h2 className="text-xl font-semibold">GST Registrations</h2>
                <button
                    type="button"
                    // onClick={() => setShowCreateGst(true)}
                    onClick={() => {
  setIsUpdateBasic({
    id: null,
    registrationNumber: "",
    gstin: "",
    registrationType: "Regular",
    activeStatus: true,
  });
  setErrors({});
  setIsGstId(null);
  setShowCreateGst(true);
}}

                    className="bg-primary text-white px-3 py-1 rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center space-x-2 w-full sm:w-auto"
                >
                    <Plus className="h-4 w-4" />
                    <span>Add GST</span>
                </button>
            </div>
            {gstList?.length !== 0 ?
            <div className="grid grid-cols-1 sm:grid-cols-4 gap-3 mt-1">
                <select
                    className="border rounded-lg px-3 py-1 text-sm"
                    value={filters.registrationType}
                    onChange={(e) =>
                    setFilters({ ...filters, registrationType: e.target.value })
                    }
                >
                    <option value="all">All GST Type</option>
                    {gstType.map((p, idx) => (
                    <option key={idx} value={p}>
                        {p}
                    </option>
                    ))}
                </select>
                <select
                    className="border rounded-lg px-3 py-1 text-sm"
                    value={filters.states}
                    onChange={(e) =>
                        setFilters({ ...filters, states: e.target.value })
                    }
                    >
                    <option value="all">All States</option>
                    {indianStatesWithGST.map((s) => (
                        <option key={s.value} value={s.value}>
                        {s.label}
                        </option>
                    ))}
                    </select>

                    <div>
                        <input
                            type="text"
                            placeholder="Search GSTIN / Registration No"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="border rounded-lg px-3 py-1 text-sm w-full"
                            />
                    </div>


                <div className="flex items-end justify-end">
                    <button
                        type="button"
                        onClick={() => {
                            setFilters({
                                registrationType: "all",
                                states: "all"
                                });
                            setSearch("");
                            }}
                        className="bg-primary py-1 px-2 rounded-md text-sm font-medium text-white hover:bg-primary [&:active_span]:animate-spin-once"
            >
                <span className="inline-block">
                                   <RefreshCcw size={18} />
                                 </span>
                    </button>
                </div>
            </div>:<></>}
            {filteredTasks.length !== 0 ? (
                <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200 text-sm">
                    <thead className="bg-gray-50">
                    <tr>
                        <th className="px-2 py-1 text-left text-slate-700">#</th>
                        <th className="px-2 py-1 text-left text-slate-700 cursor-pointer" onClick={() => handleSort("gstin")}><span className="flex flex-row items-center gap-1">GSTIN <SortIcon column="gstin" /></span></th>
                        <th className="px-2 py-1 text-left text-slate-700 cursor-pointer" onClick={() => handleSort("registrationType")}><span className="flex flex-row items-center gap-1">Registration Type <SortIcon column="registrationType" /></span></th>
                        {/* <th className="px-2 py-1 text-left text-slate-700 cursor-pointer" onClick={() => handleSort("registrationNumber")}><span className="flex flex-row items-center gap-1">Registration Number <SortIcon column="registrationNumber" /></span></th> */}
                        <th className="px-2 py-1 text-center">Actions</th>
                    </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                    {sortedTasks.map((task, index) => (
                        <tr key={index} className="hover:bg-gray-50">
                        <td className="px-2 py-1">{index + 1}</td>
                        <td className="px-2 py-1 font-medium">{task.gstin}</td>
                        <td className="px-2 py-1">{task?.registrationType}</td>
                        {/* <td className="px-2 py-1">{task?.registrationNumber}</td> */}
                        <td className="px-2 py-1 text-center space-x-1">
                            <button
                                onClick={() => {setIsUpdateBasic(task); setIsGstId(task?.id); setShowCreateGst(true);}}
                                className="text-blue-600 hover:text-blue-900"
                            >
                                <Edit className="h-4 w-4" />
                            </button>
                            <button
                                onClick={(e) => handelDelete(e, task?.id)}
                                className="text-red-600 hover:text-red-900"
                            >
                                <Trash2 className="h-4 w-4" />
                            </button>
                        </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                </div>
            ) :(
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 text-center">
                    <FiFile className="h-12 w-12 text-gray-500 mx-auto mb-4" />
                    <h3 className="text-lg font-medium text-gray-900 mb-2">
                        No GST Registrations
                    </h3>
                    <p className="text-gray-600 mb-4">
                        This client doesn't have any GST registrations yet.
                    </p>
                    {/* <button
                        onClick={() => setIsOpen(true)}
                        className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
                    >
                        Add GST Registration
                    </button> */}
                    {/* <RegisterGstModal
                        isOpen={isOpen}
                        onClose={() => setIsOpen(false)}
                        businessInfoId={selectedClientData?.businessInformation?.id}
                        initialData={[]}
    onRefreshAccounts={onRefreshAccounts}
                        onSave={(data) => {
                            console.log("Saved GST Data:", data);
                            setIsOpen(false);
                            
                        }}
                    /> */}
                </div>
                )}
            {showCreateGst && 
            <div onClick={() => setShowCreateGst(false)} className="fixed -top-6 inset-0 bg-black/40 flex items-center justify-center">
            <GSTInfoClient isGstId={isGstId} handelUpdate={handelUpdate} showCreateGst={showCreateGst} setShowCreateGst={setShowCreateGst} isLoading={isLoading} errors={errors} formData={isUpdateBasic} setFormData={setIsUpdateBasic} />
            </div>}
        </div>
    );
};

export default GSTInfoTab;